import { Fragment, useState } from 'react';

import { ArrowDropDown } from '@mui/icons-material';
import {
  AppBar,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';
import kebabcase from 'lodash/kebabCase';
import { useHistory, useParams } from 'react-router-dom';

import logo from '../../../../../assets/imgs/logo.svg';
import { markets, sections, transition } from '../../constants';
import { MarketsMenu } from '../MarketMenu';

interface YearbookParams {
  year: string;
  market?: string;
  section?: string;
}

export function Navbar() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { year, market } = useParams<YearbookParams>();
  const history = useHistory();

  const currentMarket = markets.find((m) => m === market) ?? markets[0];

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateTo = (section: string) => {
    history.push(`/anuarios/${year}/${currentMarket}/${kebabcase(section)}`);
  };

  return (
    <Hidden lgDown>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: 'transparent',
          backdropFilter: 'blur(6px)',
        }}
        elevation={0}>
        <Toolbar
          sx={(theme) => ({
            maxWidth: theme.breakpoints.values.lg,
            mx: 'auto',
          })}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mx: 0,
              gap: 10,
            }}>
            <Box
              key="logo"
              component="img"
              height={50}
              src={logo}
              sx={{ cursor: 'pointer' }}
              onClick={() => navigateTo('inicio')}
            />
            <Box
              display="flex"
              alignItems="center"
              gap={2}
              justifyContent="space-between">
              {sections.map((section) => {
                if (section?.subsections) {
                  return (
                    <Fragment key={kebabcase(section.title)}>
                      <Box
                        key={kebabcase(section.title)}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          '&:hover': { color: '#FF8211' },
                          transition,
                        }}
                        onClick={handleClick}>
                        <Typography fontFamily="Figtree">
                          {section.title}
                        </Typography>
                        <ArrowDropDown />
                      </Box>
                      <Menu
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        sx={{
                          '.MuiPaper-root': {
                            backgroundColor: 'transparent',
                            backdropFilter: 'blur(6px)',
                          },
                        }}>
                        {section.subsections.map((subsection) => (
                          <MenuItem
                            key={kebabcase(
                              `${section.title} ${subsection.title}`,
                            )}
                            onClick={() => {
                              navigateTo(
                                kebabcase(
                                  `${section.title} ${subsection.title}`,
                                ),
                              );
                              handleClose();
                            }}
                            sx={{
                              cursor: 'pointer',
                              transition,
                              '&:hover': { color: '#FF8211' },
                              color: 'white',
                            }}>
                            <Typography fontFamily="Figtree">
                              {subsection.title}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Menu>
                    </Fragment>
                  );
                }
                return (
                  <Typography
                    fontFamily="Figtree"
                    key={section.title}
                    onClick={() => navigateTo(kebabcase(section.title))}
                    sx={{
                      cursor: 'pointer',
                      transition,
                      '&:hover': { color: '#FF8211' },
                    }}>
                    {section.title}
                  </Typography>
                );
              })}
            </Box>
            <MarketsMenu />
          </Box>
        </Toolbar>
      </AppBar>
    </Hidden>
  );
}
